import {
  Stack,
  Typography,
  Grid,
  Paper,
  IconButton,
  Button,
} from "@mui/material";
import { PaymentIframe } from "../../../components/payment/PaymentIframe";
import { ArrowBack, WhatsApp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useCRMPayment } from "@/hooks/useCRMPayment";

interface PaymentCRMProps {
  onGoBack: () => void;
}

export function PaymentCRM({ onGoBack }: PaymentCRMProps) {
  const navigate = useNavigate();
  const { paymentLink, setPaymentLink, handleActivateCRMPlan, crmPlans } =
    useCRMPayment({
      onSuccess: () => {
        window.location.href = "/";
      },
    });

  // Removido código duplicado e desnecessário

  if (paymentLink) {
    return (
      <Stack sx={{ width: "100%", height: "90vh" }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ p: 2, borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
        >
          <IconButton onClick={() => setPaymentLink(null)} sx={{ p: 1 }}>
            <ArrowBack />
          </IconButton>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ flex: 1 }}
          >
            <WhatsApp color="primary" />
            <Typography variant="h6">Pagamento FluxZap</Typography>
          </Stack>
        </Stack>
        <PaymentIframe
          showBackButton={false}
          paymentLink={paymentLink}
          onBack={() => {
            setPaymentLink(null);
            navigate("/fluxzap");
          }}
        />
      </Stack>
    );
  }

  return (
    <Stack width="100%" height="100%" spacing={3} padding={4}>
      <Stack direction="row" alignItems="center" spacing={2} mb={4}>
        <IconButton onClick={onGoBack} sx={{ p: 1 }}>
          <ArrowBack />
        </IconButton>
        <Typography
          variant="h5"
          fontWeight="600"
          align="center"
          sx={{ flexGrow: 1, mr: 5 }}
        >
          Ativar FluxZap
        </Typography>
      </Stack>

      <Grid container spacing={4} justifyContent="center">
        {crmPlans.map((plan, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 2,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Stack spacing={3}>
                <Typography variant="h6" fontWeight="600" align="center">
                  {plan.title}
                </Typography>

                <Typography
                  variant="h4"
                  fontWeight="700"
                  align="center"
                  color="primary"
                >
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(plan.amount)}
                </Typography>

                <Typography
                  variant="body1"
                  color="text.secondary"
                  align="center"
                >
                  {plan.description}
                </Typography>
              </Stack>

              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 4 }}
                onClick={() => handleActivateCRMPlan(plan)}
              >
                Ativar Plano
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
